<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/reviewwelcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>作品评审</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项名称" clearable @clear="getOpusList(1)">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName"
              :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入项目名称" v-model="queryInfo.EntriesName" clearable @clear="getOpusList(1)">
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-input placeholder="请输入项目编号" v-model="queryInfo.itemNo" clearable @clear="getOpusList(1)">
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button icon="el-icon-search" type="primary" @click="getOpusList(1)">搜索</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="300">
        </el-table-column>
        <el-table-column prop="TrackName" label="赛道名称" width="300">
        </el-table-column>
        <el-table-column prop="EntriesName" label="项目名称" width="320">
        </el-table-column>
        <el-table-column prop="ItemNo" label="项目编号"> </el-table-column>
        <el-table-column prop="Score" label="项目得分" width="80">
        </el-table-column>
        <el-table-column prop="Status" label="评分状态" width="80">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.Status === 0">未评分</span>
              <span v-else-if="scope.row.Status === 2" style="color: #e6a23c">已暂存</span>
              <span v-else-if="scope.row.Status === 1" style="color: #67c23a">已评分</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.Remark" style="color: #f56c6c; font-weight: bold;">
              {{ scope.row.Remark }}
            </span>
            <span v-else style="color: #999;">-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button :type="scope.row.Status !== 1 ? 'primary' : 'warning'"
              :icon="scope.row.Status !== 1 ? 'el-icon-edit' : 'el-icon-view'" size="mini"
              @click="showEditCreate(scope.row)">{{ scope.row.Status !== 1 ? '项目评审' : '查看详情' }}</el-button>
            <el-button type="success" size="mini" @click="showProject(scope.row)">项目资料查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
      <!-- 评审 -->
      <el-dialog :title="'【' + thisPrajectName + '】作品评审'" :visible.sync="editDialogVisible" width="60%"
        :close-on-click-modal="false" @close="editresetFields">
        <el-form :model="editForm" ref="editFormRef">
          <el-table :data="tablearr" show-summary sum-text="总分" border style="width: 100%">
            <el-table-column prop="StandardName" label="标准名称" width="230"></el-table-column>
            <el-table-column prop="StandardContent" label="评分标准">
              <template slot-scope="scope">
                <div v-html="scope.row.StandardContent" style="white-space: pre-line"></div>
              </template>
            </el-table-column>
            <el-table-column prop="ReviewCriteriaScore" label="分数" width="60">
            </el-table-column>
            <el-table-column prop="Score" label="评分" width="70">
              <template slot-scope="scope">
                <!-- {{scope.row.Status}}scope.row.Score -->
                <el-input v-model="scope.row.Score" :disabled="scope.row.Status !== 1 ? false : true"
                  @blur="maxScore(scope.row)"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="totalscore">
            <span>总分:{{ (editForm.EntriesScoreRelationlist.FinalScore = aArr) }}</span>
          </div> -->
          <el-form-item label="评审意见" prop="JudgesGroupName">
            <el-input v-model="editForm.Comment" type="textarea" maxlength="200" :rows="4" show-word-limit
              :disabled="editForm.EntriesScoreRelationlist[0].Status !== 1 ? false : true"
              placeholder="请评审老师给出作品评审意见，字数限制50-200字(尽量作品评语不要一样)"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer"
          style="display:flex;align-items: center;justify-content: space-between;">
          <div style="color: red; font-size: 12px">
            提示:"暂存评分"可再次修改评分,"提交评分"后无法修改,请谨慎操作.
          </div>
          <div>
            <el-button @click="editCreate(2)"
              :disabled="editForm.EntriesScoreRelationlist[0].Status !== 1 ? false : true">暂存评分</el-button>
            <el-button type="primary" @click="editCreate(1)"
              :disabled="editForm.EntriesScoreRelationlist[0].Status !== 1 ? false : true">提交评分</el-button>
          </div>
        </span>
      </el-dialog>
      <!-- 项目资料查看 -->
      <el-dialog :title="'【' + thisPrajectName + '】作品资料列表'" :visible.sync="viewDialogVisible" width="50%">
        <el-table :data="this.ProjectData" style="width: 100%" class="mttop">
          <el-table-column prop="OldFileName" label="文件名称">
            <template slot-scope="scope">
              <div>
                <a :href="scope.row.ServerUrl + scope.row.FileName" target="_blank" class="filename">{{
                  scope.row.OldFileName }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="FileSize" label="文件大小" width="130">
            <template slot-scope="scope">
              <div>
                {{ scope.row.FileSize.toFixed(2) + 'KB' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="文件查看" width="130">
            <template slot-scope="scope">
              <div>
                <el-link :href="scope.row.ServerUrl + scope.row.FileName" target="_blank"
                  :download="scope.row.OldFileName">点击查看</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项名称
        matchName: '',
        // 项目名称
        EntriesName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,

      // 修改弹框显示状态
      editDialogVisible: false,
      // 项目资料查看弹框显示状态
      viewDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      editForm: {
        EntriesScoreRelationlist: [
          {
            StandardName: '作品难度',
            StandardContent:
              '(1)考虑作品的工作量大小(2)考虑作品的工作难易程度是否超出合理范围',
            ReviewCriteriaScore: 8,
            Score: 0,
            EntriesID: 0,
            JudgesGroupID: 0,
            JudgesID: 0,
            ReviewCriteriaID: 0,
            EntriesReviewScore: 0,
            Status: 0
          }
        ],
        // FinalScore: 0,
        Comment: '' // 评审意见
      },
      // 动态表格数据处理
      tablearr: [],
      scoringArr: [],
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [
        {
          value: '1',
          label: '赛道1'
        },
        {
          value: '2',
          label: '赛道2'
        }
      ],
      // 项目评审状态
      Status: false,
      // 项目资料
      ProjectData: [],
      // 暂存评分、提交评分是否可直接提交
      isSubmit: true,
      // 当前弹窗作品名
      thisPrajectName: ''
    }
  },
  computed: {
    // 计算总分
    aArr() {
      return this.editForm.EntriesScoreRelationlist.map((item) =>
        parseInt(item.Score)
      ).reduce((total, num) => {
        return total + num
      })
    }
  },
  created() {
    //   默认获取列表
    this.getOpusList(1)
    //   下拉获取所有赛事
    this.getAllMatch()
  },
  methods: {
    //   获取列表
    async getOpusList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEntriesReviewList',
        {
          params: this.queryInfo
        }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.entries
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      // console.log(res)
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getOpusList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.pagenum = newPage
      this.getOpusList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.$refs.editFormRef.resetFields()
    },
    // 显示创建赛事弹窗
    showAddCreate() {
      // 打开弹窗
      this.addDialogVisible = true
    },
    // 显示项目资料弹窗
    async showProject(row) {
      this.thisPrajectName = row.EntriesName
      // 项目资料发起请求
      const { data: res } = await this.$http.get(
        '/api/EntriesFile/GetEntriesFilesTypeFile',
        {
          params: {
            EntriesID: row.EntriesID,
            MatchID: row.MatchID
          }
        }
      )
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      this.ProjectData = res.Data.entriesFiles
      // 打开弹窗
      this.viewDialogVisible = true
    },
    // 显示评审弹窗
    async showEditCreate(row) {
      this.thisPrajectName = row.EntriesName
      // 发起请求
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEntriesReviewJudgesList',
        {
          params: {
            EntriesID: row.EntriesID,
            MatchID: row.MatchID
          }
        }
      )
      // 判断状态码
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      // console.log(res)
      this.editForm.EntriesScoreRelationlist = res.Data.entries
      this.editForm.Comment = res.Data.Comment
      this.tablearr = this.editForm.EntriesScoreRelationlist
      this.editDialogVisible = true
    },
    // 修改
    async editCreate(num) {
      if (num === 1) {
        const commentLength = this.editForm.Comment.length
        if (commentLength < 50 || commentLength > 200) {
          this.$message.error('评审意见字数必须在50-200字之间')
          return
        }
      }
      if (this.isSubmit === true) {
        this.editForm.EntriesScoreRelationlist.forEach((item) => {
          item.Status = num
        })
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Entries/EntriesReviewScore',
          this.editForm
        )
        console.log(this.editForm.EntriesScoreRelationlist)
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getOpusList(this.pagenum)
      } else {
        return false
      }
    },
    // 评分不能大小满分
    maxScore(row) {
      if (parseInt(row.Score) > row.ReviewCriteriaScore) {
        this.$message.error('评分大于总分，请重新输入')
        row.Score = 0
        this.isSubmit = false
      } else if (!/^[0-9]*$/.test(row.Score)) {
        this.$message.error('请输入数字')
        row.Score = 0
        this.isSubmit = false
      } else {
        this.isSubmit = true
      }
    }
  }
}
</script>
<style lang="less" scoped>
.item {
  display: flex;
  border: 1px solid #ddd;
}

.el-form-item {
  margin-bottom: 0;
}

.totalscore {
  display: flex;
  justify-content: right;
  padding-top: 20px;
  font-size: 18px;
}

.mttop {
  margin-top: 0;
}

.filename {
  text-decoration: none;
  color: #333;
}

/deep/ .el-table__footer-wrapper {
  .el-table__cell {
    &:nth-last-child(2) {
      .cell {
        font-size: 24px;
        color: red;
      }
    }
  }
}

/deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
